"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var form_1 = __importDefault(require("~/components/forms/review_form/hikakaku_review_form/form"));
var hikakaku_review_form_store_1 = __importDefault(require("~/stores/forms/reviews/hikakaku_review_form_store"));
var HikakakuReviewForm = function (props) {
    return (react_1.default.createElement(mobx_react_1.Provider, { store: new hikakaku_review_form_store_1.default(props.default_email, props.is_history_backable) },
        react_1.default.createElement(form_1.default, null)));
};
exports.default = HikakakuReviewForm;
